<template>
  <v-container class="login-container">
    <v-row class="fill-height" align="center" justify="center">
      <v-col cols="12" xs="12" sm="10" md="8" lg="6" xl="4">
        <v-card class="login-card" elevation="10">
          <v-card-text>
            <h1 style="color: #ff8282;" class="text-center font-weight-bold mt-9 mb-4">HAMWOORI ADMIN</h1> <!-- 추가된 부분 -->

            <v-form @submit.prevent="login" class="login-form">
              <v-text-field
                v-model="form.loginId"
                class="login-field"
                prepend-inner-icon="mdi-account"
                variant="outlined"
                placeholder="ID"
                density="comfortable"
                bg-color="white"
                color="primary"
                autocomplete="username"
                hide-details
              />
            
              <v-text-field
                v-model="form.loginPw"
                class="login-field mt-4"
                prepend-inner-icon="mdi-lock"
                variant="outlined"
                placeholder="PW"
                type="password"
                density="comfortable"
                bg-color="white"
                color="primary"
                autocomplete="current-password"
                hide-details
              />

              <v-checkbox
                v-model="remember"
                class="mt-2"
                color="primary"
                hide-details
                label="Remember Me"
              />

              <v-btn
                type="submit"
                class="login-btn mt-4"
                size="large"
                block
                :elevation="2"
              >
                Login
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog
      v-model="loginDialog"
      
      width="auto"
    >
      <v-card
        class="pa-4"
        style="background: #ffdef6; "
      >
        <v-card-text class="text-center">
          <v-progress-circular
            indeterminate
            color="white"
            size="64"
          ></v-progress-circular>
          <img
              v-if="account.id === 'hamwoori25' && account.name === '김아름'"
              class="gamza-image"
              src="../../assets/pictures/gamza.png"
              alt=""
            />
          <div class="text-white mt-4" style="color: #333 !important;">
        
    {{ welcomeMessage }}</div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import axios from "axios";
import { format } from 'date-fns';
import { LoginForm, Account, LoginResponse } from '../../types/types';
import '@/assets/styles/login.scss';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

const store = useStore();
const router = useRouter();
const remember = ref(false);
const loginDialog = ref(false);
const welcomeMessage = ref('');

const form = ref<LoginForm>({
  loginId: "",
  loginPw: "",
});

const account = ref<Account>({
  id: "",
  name: "",
  role: 0,
  role_name: "",
  code: "",
  sisul_name: "",
  emp_num: "",
  status: 0
});

const login = () => {
  const args = {
    loginId: form.value.loginId,
    loginPw: form.value.loginPw,
  };

  axios
    .post("/api/account", args)
    .then(async (res: LoginResponse) => {
      account.value = res.data.member;
      welcomeMessage.value = `${res.data.member.name}님, 환영합니다!`;
      loginDialog.value = true;
      
      await store.dispatch("login", {
        id: res.data.member.id,
        role: res.data.member.role,
        roleName: res.data.member.role_name,
        name: res.data.member.name,
        code: res.data.member.code,
        autoLogin: remember.value,
        sisulName: res.data.member.sisul_name,
        empNum: res.data.member.emp_num,
      });
      
      const oneMonthAgo = new Date();
      oneMonthAgo.setMonth(oneMonthAgo.getMonth());
      store.commit('setAdminYYMM', format(oneMonthAgo, 'yyyy-MM'));
      setTimeout(() => {
        router.push('/AdminIndexPage');
      }, 1500);
    })
    .catch(() => {
      alert("로그인에 실패했습니다. 계정 정보를 확인해주세요.");
    });
};

watch(
  () => [store.state.NonStopId, store.state.NonStopPw],
  ([newId, newPw]) => {
    if (newId) {
      form.value.loginId = newId;
      sessionStorage.removeItem('getNonStopId');
    }
    if (newPw) {
      form.value.loginPw = newPw;
      sessionStorage.removeItem('getNonStopPw');
    }
  }
);
</script>
